import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { ImageViewModel, PropertyInfoSectionViewModel, PropertyInfoSubSectionViewModel } from 'models';

import { PropertyDetailsSegment } from 'components/infosite/policies/internals/property-details-segment';
import { SectionBody } from './internals/section-body';
import { SectionImageLayout } from './internals/section-image-layout';
import { Sections } from './internals/sections';

interface PropertyInfoSectionProps {
  analytics?: AnalyticsStore;
  propertyInfoSection: PropertyInfoSectionViewModel;
  navigationRef?: React.RefObject<any>;
  isToggleHidden: boolean;
}

export const PropertyInfoSection: React.FunctionComponent<PropertyInfoSectionProps> = ({
  analytics,
  propertyInfoSection,
  navigationRef,
  isToggleHidden = false
}) => {
  if (!propertyInfoSection) {
    return null;
  }

  const { dataLabel, formattedText, image, sections, title, toggleHidden } = propertyInfoSection;
  const propertyInfoProp = title && ((sections && sections.length > 0) || formattedText);

  if (!propertyInfoProp) {
    return null;
  }

  const propertyAnalyticsId = toggleHidden && toggleHidden.analyticsId;
  const propertyInfoAnalytics = analytics && propertyAnalyticsId && analytics.setupTracker(`.${propertyAnalyticsId}`, 'SeeMore_SeeLess');
  const dataStid = dataLabel && `section-${dataLabel}`;
  const hasBodyAndSections: boolean = formattedText && sections ? true : false;

  return (
    <PropertyDetailsSegment
      analytics={propertyInfoAnalytics}
      dataStid={dataStid}
      errorBoundaryLabel={`hotel.info.details.${propertyAnalyticsId}`}
      rootClassName={dataLabel}
      title={title}
      isToggleHidden={isToggleHidden}
      navigationRef={navigationRef}
    >
      <SectionImageLayout propertyInfo={propertyInfoSection} />
      <SectionBody propertyInfoBody={formattedText} />
      <SectionsLayout dataStid={dataStid} hasBodyAndSections={hasBodyAndSections} image={image} sections={sections} />
    </PropertyDetailsSegment>
  );
};

PropertyInfoSection.displayName = 'PropertyInfoSection';

interface SectionsLayoutProps {
  dataStid: string;
  hasBodyAndSections?: boolean;
  image?: ImageViewModel;
  sections?: PropertyInfoSubSectionViewModel[];
}

export const SectionsLayout = ({ hasBodyAndSections, image, sections, dataStid }: SectionsLayoutProps) => {
  if (image || !sections) {
    return null;
  }

  return (
    <div className={`sections-layout ${hasBodyAndSections ? 'all-t-padding-three' : ''}`}>
      {sections.map((section, index) => (
        <Sections key={`${dataStid}-${index}`} section={section} dataStid={dataStid} />
      ))}
    </div>
  );
};

SectionsLayout.displayName = 'SectionsLayout';
